import React from 'react'


const Home = () => {
    return (
        <section className="content-area home-page">
            <div className="top-section">
                <div className="product">
                    <div className="circle">
                        <img src="img/products/adidas-yeezy-boost-350-white.png" />
                    </div>
                </div>
                <div className="titles">
                    <h3>Yeezy</h3>
                    <h1>Boost 350</h1>
                </div>
            </div>
        </section>
    )
}

export default Home